import React, { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import CustomModal from "../../common/CustomModal";
import CustomInput from "../../common/CustomInput";
import RoleAPIs from "../../../apiRoutes/Role";
import { GET_PERMISSIONS_QUERY_KEY } from "../../../utils/constants/queryKeys";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import toast from "react-hot-toast";
import { normalizeCode } from "../../../utils/helperFunctions";

const AddPermissionModal = ({ open, onClose }) => {
    const [formData, setFormData] = useState({ code: "", description: "" });
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    const { mutate: submitPermission, isPending } = useMutation({
        mutationFn: (payload) => RoleAPIs.createPermission({ axiosPrivate, payload }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: GET_PERMISSIONS_QUERY_KEY });
            toast.success("Permission created successfully!");
            setFormData({ code: "", description: "" });
            onClose();
        },
        onError: (error) => {
            toast.error(error?.response?.data?.error_message || error?.message);
        },
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        const code = formData.code?.trim();
        if (!code) return toast.error("Permission code is required");
        submitPermission({ code, description: formData.description?.trim() || "" });
    };

    const handleClose = () => {
        setFormData({ code: "", description: "" });
        onClose();
    };

    

    return (
        <CustomModal
            title="Add Permission"
            open={open}
            onClose={handleClose}
            handleConfirmation={handleSubmit}
            isLoading={isPending}
            confirmText="Create"
        >
            <div className="space-y-4 py-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Code *</label>
                    <CustomInput
                        placeholder="e.g. user.manage"
                        value={formData.code}
                        onChange={(e) => setFormData({ ...formData, code: normalizeCode(e.target.value) })}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                    <textarea
                        className="w-full p-3 border border-gray-200 rounded-lg focus:ring-1 focus:ring-primaryPurple focus:border-primaryPurple outline-none text-sm min-h-[80px]"
                        placeholder="Optional description..."
                        value={formData.description}
                        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                    />
                </div>
            </div>
        </CustomModal>
    );
};

export default AddPermissionModal;
